export default __webpack_public_path__ + "static/pic05-083f690215497660a8a84e41cb253a3d.jpg";